import { STOModel } from "src/models/base/sto-model";
import { AllowedLanguagesDTO } from "../../models/allowed-languages/allowed-language-dto";
import { BaseApiService } from "../base";

export class ProviderSitesAllowedLanguagesApiService extends BaseApiService<AllowedLanguagesDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/ProviderSites",
      loadItemsPath: "/GetAllowedLanguages",
    });
  }
}
